import React from 'react';

const ActivityIndicator = ({ size = 'small', color = 'var(--primary)', style, ...props }) => {
  const sizeMap = {
    small: 20,
    large: 40
  };
  
  const spinnerSize = typeof size === 'number' ? size : sizeMap[size] || 20;
  
  return (
    <div
      style={{
        display: 'inline-block',
        width: spinnerSize,
        height: spinnerSize,
        border: `${Math.max(2, spinnerSize / 10)}px solid rgba(0, 0, 0, 0.1)`,
        borderTop: `${Math.max(2, spinnerSize / 10)}px solid ${color}`,
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
        ...style
      }}
      {...props}
    >
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default ActivityIndicator;
